import {
  Modal,
  Box,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CustomerAutocomplete from "../customer-autocomplete";

const OrderTypeModal = ({
  open,
  onClose,
  onSubmit,
  customerId,
  selectedCustomer,
  setSelectedCustomer,
  handleSaveCustomerProfile,
  isM2O,
  setIsM2O,
  importOrder = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="create-order-modal"
      aria-describedby="modal-to-select-customer-and-order-type"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography
          id="create-order-modal"
          variant="h6"
          component="h2"
          gutterBottom
        >
          {importOrder
            ? "Select Customer"
            : customerId
            ? ""
            : "Choose Customer and Order Type"}
        </Typography>

        {!customerId && (
          <CustomerAutocomplete
            selectedCustomer={selectedCustomer}
            onCustomerChange={(c) => {
              setSelectedCustomer(c);
              handleSaveCustomerProfile(c);
            }}
            width={"100%"}
            required
          />
        )}

        {!importOrder && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" fontWeight={500} gutterBottom>
              Select Order Type
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={!isM2O}
                  onChange={() => setIsM2O(false)}
                  sx={{
                    color: "#DC585C",
                    "&.Mui-checked": {
                      color: "#DC585C",
                    },
                  }}
                />
              }
              label="M2C Order"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={isM2O}
                  onChange={() => setIsM2O(true)}
                  sx={{
                    color: "#DC585C",
                    "&.Mui-checked": {
                      color: "#DC585C",
                    },
                  }}
                />
              }
              label="M2O Order"
            />
          </Box>
        )}

        <Box
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              border: "1px solid #DC585C",
              textTransform: "none",
              fontFamily: "poppins",
              fontSize: "12px",
              fontWeight: 500,
              color: "#DC585C",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#DC585C",
              textTransform: "none",
              fontFamily: "poppins",
              fontSize: "12px",
              fontWeight: 500,
            }}
            onClick={onSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OrderTypeModal;
